import type RouterDSL from "@ember/routing/-private/router-dsl";

export default function bloodPressureRoutes(this: RouterDSL) {
  this.route("blood-pressure", function () {
    this.route("sessions", function () {
      this.route("session", { path: "/:session_id" });
      this.route("new");
    });
  });
}
